module.exports = __webpack_public_path__ + "static/the-better-angels-of-our-nature-74207b2f011299fe1fb890f1187cb9d9.jpg";